var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Aedu.NavigationController = function (superClass) {
  extend(NavigationController, superClass);
  function NavigationController() {
    return NavigationController.__super__.constructor.apply(this, arguments);
  }
  NavigationController.prototype.events = {
    'click .js-main-nav-my-account-link': 'toggleMyAccountMenu'
  };
  NavigationController.prototype.initialize = function (options) {
    if (options == null) {
      options = {};
    }
    this.showHighlightedNotification = options.showHighlightedNotification;
    return $(function (_this) {
      return function () {
        return _this.render();
      };
    }(this));
  };
  NavigationController.prototype.render = function () {
    this.ui = {
      $myAccountLink: this.$('.js-main-nav-my-account-link'),
      $myAccountMenu: this.$('.js-main-nav-my-account-menu'),
      $notificationsLink: this.$('.js-main-nav-notifications-link-container'),
      $discussionsMenu: this.$('.js-main-nav-discussions-dropdown-trigger')
    };
    this.closeDropdownsOnEscape();
    this.initializeMyAccountHover();
    this.notificationContainerView = new Aedu.NotificationContainerView({
      el: this.ui.$notificationsLink,
      showHighlightedNotification: this.showHighlightedNotification
    });
    return this.listenTo(this.notificationContainerView, "closeNavDropdowns", this.hideAll);
  };
  NavigationController.prototype.closeDropdownsOnEscape = function () {
    return $(document).keydown(function (_this) {
      return function (e) {
        if (e.keyCode === 27) {
          return _this.hideAll();
        }
      };
    }(this));
  };
  NavigationController.prototype.initializeMyAccountHover = function () {
    var $myAccountLink, $myAccountMenu, ref;
    if ($a.is_mobile()) {
      return;
    }
    ref = this.ui, $myAccountLink = ref.$myAccountLink, $myAccountMenu = ref.$myAccountMenu;
    return _.each([$myAccountLink, $myAccountMenu], function (_this) {
      return function (c) {
        return c.hover(function () {
          $myAccountMenu.data('hovered', true);
          if (!$myAccountLink.hasClass('account_open')) {
            _this.hideAll();
            $myAccountMenu.fadeIn(200);
            return $myAccountLink.addClass('account_open');
          }
        }, function () {
          $myAccountMenu.data('hovered', false);
          return _.delay(function () {
            if (!$myAccountMenu.data('hovered')) {
              $myAccountMenu.fadeOut(200);
              return $myAccountLink.removeClass('account_open');
            }
          }, 1000);
        });
      };
    }(this));
  };
  NavigationController.prototype.toggleMyAccountMenu = function (e) {
    e.preventDefault();
    if ($a.is_mobile()) {
      return this.ui.$myAccountMenu.toggle();
    }
  };
  NavigationController.prototype.hideAll = function () {
    this.ui.$myAccountMenu.hide();
    this.ui.$discussionsMenu.parent().removeClass('open');
    this.ui.$myAccountLink.removeClass('account_open');
    return this.notificationContainerView.trigger("closeNotificationDropdown");
  };
  return NavigationController;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;